import { getDateRangeTooltip } from './datetime';

//deprecated
export const getTooltipText = (
  item: any,
  lang: string,
  options?: { dateRange: boolean; prefix?: string }
): string => {
  if (options?.dateRange) {
    const prefix = options?.prefix;
    const tooltip = getDateRangeTooltip(item.fromDate, item.toDate, true, lang);
    return prefix ? `${prefix}: ${tooltip}` : tooltip;
  }
  return Array.isArray(item)
    ? item.map((i: any) => i.name).join(', ')
    : item.name;
};

export enum SELECTION {
  MULTIPLE,
  SINGLE,
  ALWAYS,
}
